












import { Component } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import ChangeLanguage from '@/mixins/ChangeLanguage';
import Item from '@vuex-orm/core/lib/data/Item';
import Marker from '@/marker/Marker';
import MarkerDetails from '@/components/marker/MarkerDetails.vue';
import MarkerDetailsEmbed from '@/components/marker/MarkerDetailsEmbed.vue';

@Component({
    components: {
        MarkerDetails,
    },
})
export default class MarkerDetail extends mixins(ChangeLanguage) {
    private get marker(): Item<Marker> {
        const id = this.$route.params.marker;

        return Marker.query()
            .whereId(id)
            .withAllRecursive()
            .first();
    }

    private get markerComponent() {
        if (this.marker?.marker__type === 'embed_marker') {
            return MarkerDetailsEmbed;
        }
        return MarkerDetails;
    }

    private navigateToLocation(): void {
        const location = this.$route.params.location;
        const to = this.$router.resolve({
            name: 'location',
            params: {
                locale: this.currentLanguage.code,
                location,
            },
        });

        this.$router.push(to.location);
    }
}
